import React, {
	useRef,
	useState,
	useEffect,
	useContext
}									from "react";
import {
	Link,
	useParams,
	useLocation
}									from "react-router-dom";
import {
	Col,
	Row,
	Form,
	Nav,
	NavLink,
	Card,
	Button,
	ListGroup,
	Badge,
	Alert,
	Modal,
	Dropdown,
	ButtonGroup,
	DropdownButton,
	Toast,
	Tab,
	Tabs,
	Container
}									from "react-bootstrap";
import Accordion					from 'react-bootstrap/Accordion';
import Select						from "react-select";
import ReactDOM						from "react-dom";
import SelectWrp					from "../components/SelectWrp";
import ServiceBar					from "../components/ServiceBar";
import OwnerFetcher					from "../components/OwnerFetcher";
import ProjectQuickSearch			from "../components/ProjectQuickSearch";
import Footer						from "../layouts/Footer";
import Sidebar						from "../layouts/Sidebar";
import DialogScenario				from "../layouts/DialogScenario";
import DialogSaveScenario			from "../layouts/DialogSaveScenario";
import DialogDeleteScenario			from "../layouts/DialogDeleteScenario";
import DialogDownloadScenario		from "../layouts/DialogDownloadScenario";
import DialogRequestOwners			from "../layouts/DialogRequestOwners";
import DialogDialog					from "../layouts/DialogDialog";
import DialogNotes					from "../layouts/DialogNotes";
import DialogViewNotes				from "../layouts/DialogViewNotes";
import DialogSetMain				from "../layouts/DialogSetMain";
import DialogVersions				from "../layouts/DialogVersions";
import DialogOwner					from "../layouts/DialogOwner";
import DialogChangeColor			from "../layouts/DialogChangeColor";
import DialogTerminate				from "../layouts/DialogTerminate";
import DialogDeleteDialog			from "../layouts/DialogDeleteDialog";
import DialogAssociateOwner			from "../layouts/DialogAssociateOwner";
import DialogDisassociateProperty	from "../layouts/DialogDisassociateProperty";
import DialogProjectSettings		from "../layouts/DialogProjectSettings";
import dialogTypes					from "../data/dialogTypes";
import LegendCircles				from "../layouts/LegendCircles";
import ScenarioSwitch				from "../components/ScenarioSwitch";
import Header						from "../layouts/Header";
import PanelLand					from "../layouts/PanelLand";
import {baseMaps}					from "../data/baseMaps";
import {customIcons}				from "../data/customIcons";
import DataTable					from 'react-data-table-component';
import {propertyStatusColor}		from "../data/PropertyStatusColor";
import wmConfig						from "../data/wmConfig";
import { 
	useContextMenu, 
	Menu, 
	Item }							from 'react-contexify';
import {
	updateGeojsonOwner,
	updateGeojsonOwnerColor,
	formatDate,
	removePropertyFromOwner,
	formatAreaFromKm,
	createUnknownOwner,
	isLand,
	norm,
	sortByDate2
}									from "../utils/functions";
import {
	setUrlParam,
	formatArea,
	randomId,
	userAddRecent
}									from "../utils/functions";
import { ReactPhotoSphereViewer }	from 'react-photo-sphere-viewer';
import globalContext				from "../utils/globalContext";
import html2canvas					from 'html2canvas';
import {
	PencilSimple,
	DotsThreeVertical,
	Notebook,
	BookOpen,
	DeviceRotate,
	Eye,
	EyeSlash,
	Crosshair,
	X,
	Windmill,
	ArrowUUpLeft,
	ArrowUUpRight,
	Trash,
	Plus,
	Book,
	PencilLine,
	User,
	MapPinSimple,
	Bridge,
	CarProfile,
	Info,
	StackSimple,
	ChatCircleText,
	Ruler,
	LineSegment,
	Lightning,
	Files,
	Notepad,
	Pencil,
	Key,
	House,
	Resize,
	UserSquare,
	SolarPanel,
}									from "@phosphor-icons/react";
import TurbineIcon					from "../assets/svg/TurbineIcon";
import OwnerObj						from "../classes/Owner";
import ScenarioObj					from "../classes/Scenario";
import PropertyObj					from "../classes/Property";
import Country						from "../classes/Country";
import ToolAnnotation				from "../classes/ToolAnnotation";

import {
	projectPhaseColors, 
	projectStatusColors
}									from "../data/ProjectStatusColor";

import "react-contexify/dist/ReactContexify.css";

import TurfCentroid					from '@turf/centroid';
import TurfLength					from '@turf/length';
import TurfCenterOfMass				from '@turf/center-of-mass';
import TurfArea						from '@turf/area';
import MapboxDraw					from "@mapbox/mapbox-gl-draw";


import mapboxgl						from '!mapbox-gl'; // eslint-disable-line import/no-webpack-loader-syntax

import key							from '../data/mapboxKey'; // eslint-disable-line import/no-webpack-loader-syntax

import {Minimap}					from "../components/minimap";
import {ShowMap}					from "../components/ShowMap";
import DoNowButton					from "../components/DoNowButton";
import DataTableFilter				from "../components/DataTableFilter";

import {drawUtils}					from "../utils/drawUtils";
import drawTheme					from "../utils/drawUtilsTheme";
import vindrApi						from "../utils/vindrapi";
import authApi						from "../utils/authApi";
import layerEvents					from "../utils/layerEvents";
import customControls				from "../utils/customControls";
//import workModePanel				from "../utils/workModePanel";
import turbineControl				from "../utils/turbineControl";
import turbine3d					from "../utils/turbine3d";
import boundaryMode					from "../utils/boundaryMode";
import powerlineMode				from "../utils/powerlineMode";
import measureMode					from "../utils/measureMode";
import roadMode						from "../utils/roadMode";
import limited_simple_select		from "../utils/simple_select";
import limited_direct_select		from "../utils/direct_select";
import Loader						from "../components/Loader";
import log							from "../utils/log";
import LayerPanel					from "../components/layerPanel";
import InfoLayers					from "../components/InfoLayers";
import PowerRoadsPanel				from "../components/PowerRoadsPanel";



mapboxgl.accessToken = key;

var du;	//drawutils
var tc;	//Turbine control
var t3d; //turbine 3d view controller 
var le;	//layerevents object
var projectData; //project information from API
var geoJson;	//container for the current geojson 
var record;
var clickedOwner					= null;	//used to know if owner pop is open, to avoid flickering
var clickedLand						= null;	//used to know if owner pop is open, to avoid flickering
var ownersPersist;					//we need this so we can access owners ouside render time (map click on a polygon)
var lastHoveredId					= 0;


var ownersSort = {
	"column": "number", 
	"direction":"asc"
};
export default function WindProject() {
	
	const location = useLocation();
	const context = useContext(globalContext);
	
	document.body.className="project";

	// Get scenario id if exists
	var scenarioid = parseInt(new URLSearchParams(location.search).get('scenarioid'));
	var versionid = parseInt(new URLSearchParams(location.search).get('versionid'));
	var startWorkmode = new URLSearchParams(location.search).get('workmode')
	
	scenarioid = Number.isNaN(scenarioid) ? 0 : scenarioid;
	versionid = Number.isNaN(versionid) ? 0 : versionid;
	
	const [pageTitle,setPageTitle]		= useState('Project');
	const [pageSubTitle,setPageSubTitle]= useState('');
	
	/*
	assign the colors to the diferent project status, maybe reuse this in other parts
	*/
	const colors = {
		"Signed":				"#068a0d",
		"Declined":				"#dc063c",
		"Interested":			"#ffd76c",
		"Not contacted":		"#e5e9f1",
		"Contacted":			"#166ee2",
		"Unreachable":			"#616670",
		"Ready to sign":		"#9be095",
		"Competitor":			"#dd03a8",
		"default":				"#045a8d",
		
	}
	const projectLayers = [
		{"label": "Status", "value":"status"},
		{"label": "Owners", "value":"owners"}
	];

	

	/* these are the color fill rules for the layers, owner color comes from geojson, project status comes from colors array we created*/
	const colorProfiles = {
		"owners" :				["get", "color"],
		"status" :				["match", ["get", "status"],...propertyStatusColor.asMapboxStyle()]
	};

	const params						= useParams();
	const {title}						= context;
	
	const projectsFile					= '/data/projects.json';
	const geojsonFile					= '/data/projects/geodata/'+params.id+'.geojson';
	const ownersFile					= '/data/projects/landowners/'+params.id+'.json';
	const mapStyles						= baseMaps;

	const ownerLink						= 'https://airtable.com/appH8XPx2xk1Tnwjv/pagY84HG8a6X4pPRG?fFhLU=';
	const ownerDialog					= 'https://airtable.com/appH8XPx2xk1Tnwjv/pag6GPufe0lqYXW4G';
	
	var center							= [];
	var tooltips						= {};
	var hoveredPolygonId				= null;
	var tb								= null; // container for threebox;

	const defaultProjectLayer			= projectLayers[1]; //what layer to show, default show status	
	const defaultShowPowerline			= true;
	const defaultShowRoads				= true;
	const defaultShowProperties			= true;
	const defaultShowTurbines			= true;
	const defaultShowEllipses			= true;
	const defaultShowBoundary			= true;
	const defaultShowTurbineNames		= false;
 
	const [errors,setErrors]							= useState(new Set()); //what layer to show, default show owners
	const [user,setUser]								= useState({});
	const [copyScenario,setCopyScenario]				= useState(false); //displays copy scenario dialog if true
	const [scenario, setScenario]						= useState(null); //container for the current project info
	const [saveScenario,setSaveScenario]				= useState({open:false}); //displays save scenario dialog if true
	const [requestLandOwners,setRequestLandOwners]		= useState({open:false}); //displays request land owners dialog
	const [setMain,setSetMain]							= useState({open:false}); //displays set main scenario dialog
	const [terminate,setTerminate]						= useState({open:false}); //displays terminate project dialog
	const [versions,setVersions]						= useState({open:false}); //displays scenario vertions dialog
	const [addNotes,setAddNotes]						= useState({open:false}); //displays add note dialog
	const [viewNotes,setViewNotes]						= useState({open:false}); //displays view notes dialog dialog
	const [downloadScenario,setDownloadScenario]		= useState({open:false}); //displays save scenario dialog if true
	const [pwrRdsPanel,setPwrRdsPanel]					= useState({open:false}); //displays roads and power lines dialog if true
	const [deleteScenario,setDeleteScenario]			= useState(false); //displays delete scenario dialog if true
	const [deleteDialog,setDeleteDialog]				= useState(false); //displays delete dialog dialog if true
	const [disassocProp,setDisassocProp]				= useState({open:false}); //displays remove property dialog if true
	const [changeColor,setChangeColor]					= useState({open:false}); //displays remove property dialog if true
	const [editOwner,setEditOwner]						= useState({open:false, owner:false}); //displays save owner	dialog if true
	const [data,setData]								= useState([]); //list of all projects, wee need this for the basic project info
	const [loaded,setLoaded]							= useState(false); //status variable set when all data is loaded
	const [assocDialog,setAssocDialog]					= useState({open:false}); //associate owner to property dialog setup
	const [settingsDialog,setSettingsDialog]			= useState({open:false}); //state control for the settings dialog

	const [projectStatuses,setProjectStatuses]			= useState(false);
	const [scenarios,setScenarios]						= useState([]);
	const [projectLayer,setProjectLayer]				= useState(defaultProjectLayer);
	const [refresh,setRefresh]							= useState([]); //variable just to refresh
	const [workMode,setWorkMode]						= useState(wmConfig.get(startWorkmode ? startWorkmode : wmConfig.defaultWorkmode));
	const [owners,setOwners]							= useState([]); //container for the owners json file
	const [owner,setOwner]								= useState(null); //set if user is selected from the list
	const [land,setLand]								= useState(null); //set if plot  is selected from the map
	const [ownersRef, setOwnersRef]						= useState([]); //references for the dom elements in owners	list
	const [panoramicImage, setPanoramicImage]			= useState({}); //references for the 360 image

	const [filterText, setFilterText]					= useState(''); //references for the 360 image


	const statusesRef									= useRef([]); //references for the dom elements in project status list

	const [project,setProject]							= useState(null); //container for the current project info

	const mapContainer									= useRef(null);
	const panoramicRef									= useRef(null);
	const layerPanelRef									= useRef(null);
	const infoLayerPanel								= useRef(null);
	const servBarPanel									= useRef(null);
	const [selectedScenario, setSelectedScenario]		= useState(null);
	const [selectedBaseLayer, setSelectedBaseLayer]		= useState(null);
	const map											= useRef(null);
	const [zoom, setZoom]								= useState(12);

	const {show}	= useContextMenu({
		id: 'layer_opacity_control',
	});
	context.dialogs = {
		setEditOwner		: setEditOwner,
		setDisassocProp		: setDisassocProp,
		setChangeColor		: setChangeColor,
		setAssocDialog		: setAssocDialog,
		setCopyScenario		: setCopyScenario
	};
	context.setters = {
		setOwners			: setOwners,
		setOwner			: setOwner,
		setLand				: setLand,
		setProject			: setProject,
	};
	context.getters = {
		owners				: owners,
		owner				: owner,
		user				: user,
		land				: land,
		project				: project,
		selectedScenario	: selectedScenario,
		workMode			: workMode,
		scenarios			: scenarios,
		scenario			: scenario
	};
	
	context.tc				= tc;
	context.versionid		= versionid;
	
	MapboxDraw.modes.simple_select = {...MapboxDraw.modes.simple_select, ...limited_simple_select};
	MapboxDraw.modes.direct_select = {...MapboxDraw.modes.direct_select, ...limited_direct_select};
	
	const Draw = new MapboxDraw({
		displayControlsDefault: false,
		controls: {
			//polygon: true,
			//line_string:true,
			//trash: true,
			boundary_mode:true
		},
		userProperties:true,
		styles: drawTheme,
		modes: {...MapboxDraw.modes, ...{boundary_mode: boundaryMode, powerline_mode:powerlineMode, road_mode:roadMode, measure_mode:measureMode}}
	});
	
	

	
	const [hasChanges,setHasChanges]		= useState(false);
	
	const undo = (h) => {
		var b = record.back(h);
		if(b)
			showScenario(selectedScenario, b, true);
	}
	
	const redo = (h) => {
		var a = record.forward();
		if(a)
			showScenario(selectedScenario, a, true);
	}
	const save = (e, rename) => {
		if(!scenario.modified && !rename && !scenario.kinks)
			return;
		
		tc.scenario.modified = 0;
		
		setSaveScenario({open:true, scenario:scenario, user:user, rename:rename, onAfter:(data)=>{
			
			if(!data)
				return;
			const scenarioid = data.scenario_id ?? data.scenarioid;
			
			var newScenarios = [...scenarios];
			newScenarios.forEach((s)=>{
				if(s.value == scenarioid)
					s.label = data.name;
			});
			var newpd = {...project};
			var idx = newpd.scenarios.findIndex((s)=>{return s.scenarioid == scenarioid});
			
			if(idx !== -1)
				Object.assign(newpd.scenarios[idx], data);
			
			setScenarios(newScenarios);
			setProject(newpd);
			showScenario(selectedScenario)
		}});
	}
	const request = () => {
		setRequestLandOwners({open:true});
	}
	const download = () => {
		if(!scenario)
			return;
		setDownloadScenario({open:true, scenario:scenario});
	}
	const duplicateScenario = () => {
		setCopyScenario({open:true, user:user, selected:selectedScenario, projectid:params.id, options:scenarios, versionid:versionid});
	}
	const delScenario = () => {

		setDeleteScenario({open:true, scenario:scenario, user:user, onClose:()=>{
				window.location.href = '/pages/project/'+scenario.projectid;
		}});
	}
	const handleAddCircle = (scenario) => {

		du.drawCircles(scenario);
	}
	const handleAddDialog = (dialog) => {
		
		var diags = owner.dialogs.slice(0);
		dialog.type = dialog.dialogType;
		dialog.timestamp = (new Date()).toISOString();
		diags.unshift(dialog);
		
		var newOwner = {...owner, ...{dialogs:diags}};
		
		setOwner(newOwner);
		
		updateOwner(newOwner);
		
	}
	const highlightPropertyInList = (id, state)=>{
		
		if(hoveredPolygonId != id)
			highlightPropertyInList(hoveredPolygonId, false);
		
		document.querySelectorAll('.property_'+id).forEach((i)=>{
			i.classList[state ? 'add' : 'remove']('active');
		});
		
	}
	
	const handleDeleteDialog = (id) => {
		
		var idx = owner.dialogs.findIndex((d)=>{return d.id == id});
		if(idx>-1){	
			var diags = owner.dialogs.slice(0);
			
			diags.splice(idx, 1);

		
			var newOwner = {...owner, ...{dialogs:diags}};

			setOwner(newOwner);

			updateOwner(newOwner);
		}
	}
	const handleDisassociateProperty = (idProperty, idOwner) => {
		
		//remove the property from the owner

		if(owner){
			var newOwner = removePropertyFromOwner(owner,idProperty); 
			updateOwner(newOwner);
		}
		var newScenario  = {...scenario};
		
		//remove the property from the owner in ownerlist
		
		var oIdx =	newScenario.landowners.findIndex((o)=>o.id == idOwner);
		if (oIdx !== -1) {
			var newO = removePropertyFromOwner(newScenario.landowners[oIdx], idProperty);
			if(!newO.properties.length)
				newScenario.landowners[oIdx] = createUnknownOwner(idProperty, oIdx);
		}
		
		
		//remove the owner from the property
		
		var pIdx = newScenario.properties.features.findIndex((f)=>f.properties.vindrid == idProperty);
		
		newScenario.properties.features.forEach((p)=>{
			var opIdx = p.properties.ownerid.indexOf(idOwner);
			if (opIdx !== -1) {
				p.properties.ownerid.splice(opIdx, 1);
				if(!p.properties.ownerid.length){
					p.properties.color = process.env.REACT_APP_PLOT_NO_OWNER_COLOR;
					p.properties.description = oIdx+1;
					p.ownerid = 'temp_'+oIdx;
					p.properties.ownerid = [p.ownerid];
				}
				else {
					//set color from another owner
					var rIdx =	newScenario.landowners.findIndex((o)=>o.id == p.properties.ownerid[0]);
					p.properties.color = newScenario.landowners[rIdx].color;
				}

			}			
			
		})
		
		var owners = newScenario.landowners;
		var geodata = newScenario.properties;

		setOwners(owners);
		ownersPersist = owners;
		geoJson = geodata;
		updateGeoJsonLayer(geodata);

		setScenario(newScenario);
		//showScenario(null, newScenario,null, null, workMode.value);

		
		setOwner(newOwner);
	}
	const handleAddNotes = (notes) => {
		
		notes.date = (new Date()).toISOString();
		notes.note = notes.text;
		
		setProject((project)=>{
			project.notes.unshift(notes);
			return project;
		});
		
	}
	const updateOwner = (owner) =>{
		var idx = owners.findIndex((o)=>o.id==owner.id);
		if(idx>-1) {
			setOwners((owners)=> {
				owners[idx] = owner;
				return owners;
			})
		}
	}
	
	
	const handleSaveOwner = (savedData) => {
		
		//check if user is changing color
		if(savedData.color && savedData.id){
			workMode.obj.updatePropertyColor(savedData.id, savedData.color);
		}
		if(savedData){
			//update owner info in the dialog
			var newOwner = {...owner, ...savedData};
			
			//if creating an owner when clicking a unknown plot
			if(!newOwner.selectedPlots)
				setOwner(newOwner); 
			
			//update ownerinfo in the owner array
			
			updateOwner(newOwner);
		}
		//update the ownerid in the property
		if(savedData && savedData.propertyid){
			
			updateGeojsonOwner(geoJson, savedData.propertyid, savedData.id);
			updateGeoJsonLayer(geoJson);
			
			ownersPersist.push(savedData);
			setOwners((owners)=>{return owners.push(savedData)});
			delete savedData.propertyId;
			delete savedData.projectId
			setOwner(savedData);
		}
		
		//setEditOwner({open:false, owner:false});
	}
	const changePropertyState = async (id, state, idOwner) => {
		
		
		const res = await vindrApi.updateProperty(id, state, workMode.value, idOwner, project.country);
		if(res && res.updateSuccess){
			
			var owner = ScenarioObj.getOwner(tc.scenario, idOwner);
			if(owner)
				OwnerObj.changePropertyState(owner, id, state);
			
			var newState = PropertyObj.getLowestState(
				propertyStatusColor.getList(), 
				tc.scenario, 
				id
			);
			
			updateGeoJsonPropertyState(id, newState);
		}
		
		return res;

	}
	const changePropertyOwner = async (id, oId, info, selectedOwner) => {
		//info is the dialog setup, with the property id, and the callback for then whe owner is updated
		
		const res = await vindrApi.updatePropertyOwner({propertyId:id, projectId:params.id, scenarioId:scenario.scenario_id}, oId);
		if(res && res.updateSuccess){
			updateGeojsonOwner(geoJson, id, oId);
			updateGeoJsonLayer(geoJson);
			
			var owner = ownersPersist.find((o)=>o.id==oId);
			
			//here we have to reload the scenario
			
			//if property is inside project
			if(info.projectId){
				showScenario(selectedScenario, params.id, null, null, workMode.value);
				return;
			}
			//else property and owner are in cadastral layer
			if(!owner){
				owner = selectedOwner;
				owner.cadastralLayer = true;
				owner.identifyer = owner.id;
			}
			if(!owner.properties)
				owner.properties = [];
			
	//			//add property to the owner for the current session, so the map is highlighted
	
			if(owner.properties.findIndex(a=>a.id==id) == -1){
				owner.properties.push({
					"area":0,
					"areaPercentage" : 0,
					"id": id,
					"name" : "",
					"status":"Not contacted"
				});
			}
			
			setOwner(owner);
			if(info.cadastralLayer){
				info.callback([owner]);
				//set the plot as white, in the cadastral map
			}
			
		}
		return res;

	}

	useEffect(()=>{
		getData();
	},[])	
	
	const processOwnersAndLands = (ownersList, geodata) => {
		
		var statusList = propertyStatusColor.getList();
		
		//put properties without owner in the end
		geodata.features.sort((a,b)=>{
			return (!!a.properties.ownerid.length === !!b.properties.ownerid.length) ? 0 : !!a.properties.ownerid.length ? -1 : 1;;
		}).map((m,idx)=>{m.id = idx+1});
		
//		if(Array.isArray(ownersList))
//			ownersList.map((owner, key) => {
//				var foundMatches = geodata.features.filter((land)=>land.properties.ownerid.includes(owner.id));
//				if(foundMatches && foundMatches.length) {
//					foundMatches.forEach((foundMatch)=>{
//						
//						owner.color = foundMatch.properties.color;
//						foundMatch.properties.description = ((foundMatch.properties.description) ? (foundMatch.properties.description + ", " + parseInt(key+1)) : parseInt(key+1));
//					});
//				}
//			});
		if(Array.isArray(ownersList))
			geodata.features.map((i, key)=>{
				
				var id = false;
				var oKey = ownersList.length;
				
				ownersList.map((o, idx)=>{
					if(o.properties){
						var found = o.properties.find((prop)=>prop.id == i.properties.vindrid);
						if(found){
							o.color = i.properties.color;
							o.number = idx+1;
							i.properties.description = ((i.properties.description) ? (i.properties.description + ", " + o.number) : o.number);
							id = o.id;
						}
					}
				});
				
				i.properties.statusDescription = statusList.findIndex((item)=>{return item == i.properties.status})+1;
				i.ownerid = id;
				//i.id = oKey;
				
				//add unknown owner
				if(!i.properties.ownerid.length && !id && isLand(i)){
					ownersList.push(createUnknownOwner(i.properties.vindrid, oKey));
					i.properties.description = ownersList.length;
					i.properties.ownerid = ['temp_'+oKey];
				}
				if(!i.properties.ownerid.length && id){
					i.properties.ownerid = [id];
				}
				
				
				return i;
			});
			ownersList.sort((a,b)=>{return a.number-b.number});
	}
	
	
	
	const getData = ()=>{ 
		

		
		Promise.all([vindrApi.getToken()])
		.then((res) => {
			return Promise.all([authApi.getUser()]);
		})
		.then((res) => {
			const user = res[0];
			
			const dataRequests = [
				vindrApi.getProject(params.id, user.userDetails),
				vindrApi.getScenario(params.id,scenarioid ? scenarioid : 0,versionid ? versionid : 0, workMode.value, user.userDetails),
				user,//,
				vindrApi.getScenarioAEP(params.id, scenarioid ? scenarioid : 0),
				vindrApi.getTurbineTypes(),
				vindrApi.getTurbineHeights(),
				vindrApi.getAnnotations(params.id, scenarioid ? scenarioid : 0),
			];
			return Promise.all(dataRequests);
		})
		.then((res)=>{
			
			var responses = res.map((response) => {
				if(response.json)
					return response.json();
				return response;
			});
			return Promise.all(responses);
		})
		.then((responses)=>{
			
			//var projectList = responses[0];
			projectData					= responses[0];
			var scenarioData			= responses[1];
			var u						= responses[2];
			var geodata					= scenarioData.properties;
			var scenarios				= projectData.scenarios;
			//scenarioData.layerLibrary	= responses[3];
			setSelectedBaseLayer(layerPanelRef.current.selected = mapStyles[projectData.base_layer-1]);


			scenarioData.aep = responses[3];
			scenarioData.turbine_types = responses[4];
			scenarioData.hub_heights = responses[5];
			scenarioData.annotations = responses[6];

//				
//			//sync layer names, and legend
//			scenarioData.layerLibrary.forEach((i)=>{
//				var idx = scenarioData.layers.findIndex((l)=>{
//					return l.vindrId == i.id;
//				});
//				if(idx > -1){
//					//scenario.layers[idx].text = i.name;
//					scenarioData.layers[idx].data.legend = i.legend;
//				}
//			});

			setUser(u);
			wmConfig.user = u;
			wmConfig.country = projectData.country;
			
			//add current project to user object and update it
			userAddRecent(u, params.id);
			
			vindrApi.updateSettings(u);
			
			//var project = projectList.find(item => item.projectid == params.id);
			
			projectData.numProperties	= geodata.features ? geodata.features.length : 0;
			
			setProject(projectData);
			
			setPageTitle("Project "+projectData.name);
			
			
			var options = sortByDate2(scenarios, "updated", "desc").map(item => {return {"label": item.name, "value":item.scenarioid};});
			setScenarios(options);
			var preselected = -1;
			//console.log(options);
			//if scenarioid comes in url, change to it
			preselected = options.findIndex((elem)=>elem.value == scenarioid);
			setSelectedScenario(options[preselected]);
					
			if(geodata.features)
				setProjectStatuses(
					Array.from(
						new Set(geodata.features.map(
							land => land.properties.status
						))
					)
				);
			
			
			center = TurfCenterOfMass(scenarioData.boundary.geometry).geometry.coordinates;

			geoJson = geodata;
			renderMap();
			map.current.on('load', () => {
				//addGeoJsonLayer(geoJson);
				changeBaseLayer({value:projectData.base_layer-1}, ()=>{
					//we need to send "u", otherwise user data is not available imediatly after load
					showScenario(options[preselected], scenarioData, false, u, wmConfig.defaultWorkmode);
				}, 
				/* scenariodata for the properties opacity on the first load*/
				scenarioData);
				
			});
			
			//this section configures workmode, idealy changeworkmode function should be used, when "project" is upgraded to work like workmodeall 
			workMode.obj.map			= map.current;
			workMode.obj.refresh		= setRefresh;
			workMode.obj.setOwner		= setOwner;
			workMode.obj.setOwners		= setOwners;
			workMode.obj.setLand		= setLand;
			workMode.obj.setEditOwner	= setEditOwner;
			workMode.obj.handleSaveOwner= handleSaveOwner;
			workMode.obj.tc				= tc;
			workMode.obj.context		= context;
			
			document.title = projectData.name+' - '+process.env.REACT_APP_DOC_TITLE;
			
			setLoaded(true);
		}).catch((e)=>{
			console.log(e);
			
			setLoaded(true);
			setErrors(p => [...p, 'Error fetching data']); //add this error to previous errors
		});
		return;

	};
	
	
	const toggleminimap = () =>{
		
	}	
	const renderMap = () => {
		if (map.current || errors.length)
			return; // initialize map only once
		map.current = new mapboxgl.Map({
			container: mapContainer.current,
			style: mapStyles[projectData.base_layer-1].value,
			center: center,
			zoom: zoom,
			preserveDrawingBuffer:true
		});
		map.current.initialCenter = center;
		
		map.current.layerStatus			= {}
		map.current.layerStatus['pl_layer']					= defaultShowPowerline;
		map.current.layerStatus['rd_layer']					= defaultShowRoads;
		map.current.layerStatus['owner-numbers']			= defaultShowProperties;
		map.current.layerStatus['status-numbers']			= defaultShowProperties;
		map.current.layerStatus['project-geojson-fill']		= defaultShowProperties;
		map.current.layerStatus['project-geojson-stroke']	= defaultShowProperties;
		map.current.layerStatus['turbines']					= defaultShowTurbines;
		map.current.layerStatus['ellipses']					= defaultShowEllipses;
		map.current.layerStatus['boundary']					= defaultShowBoundary;
	
		
		map.current.currentStyle		= mapStyles[projectData.base_layer-1];
		map.current.projectLayer		= defaultProjectLayer.value;
		map.current.controlBar			= {};
		map.current.dragRotate.disable();
		if(!defaultShowTurbines)
			map.current.getContainer().classList.add('hide-turbines');
		
		record				= new log(map.current, setHasChanges);
		du					= new drawUtils(map.current, Draw, context);
		tc					= new turbineControl(map.current, du, scenario, setScenario, ()=>{return record;});
		tc.serviceBar		= servBarPanel;
		tc.infoLayers		= infoLayerPanel;
		tc.undo				= undo;
		tc.changeWorkMode	= changeWorkMode;
		t3d					= new turbine3d(map.current, scenario);
		var controlBar		= new customControls({ //turbine control extends draw control and adds both controls
			draw: Draw,
			buttons: [
			{
				on: 'click',
				id: 'measure_modeon',
				action: (e)=>{tc.measureMode(e)},
				title: 'Measure',
				classes: ['customControl', 'svg', 'disabled'],
				icon: <Ruler size={20} />,
			},
			{},
			{
				on: 'click',
				id: 'annotation_modeon',
				action: (e)=>{tc.annotationMode(e)},
				title: 'Annotations',
				classes: ['customControl', 'svg', 'disabled'],
				icon: <ChatCircleText  size={20} />,
			},
			{
				on: 'click',
				id: 'boundary_modeon',
				action: (e)=>{tc.boundaryMode(e)},
				title: 'Boundaries',
				classes: ['customControl', 'svg', 'disabled'],
				icon: <LineSegment size={20} />,
			},
			{
				on: 'click',
				id: 'road_modeon',
				action: (e)=>{tc.roadMode(e)},
				title: 'Roads',
				classes: ['customControl', 'svg', 'disabled'],
				icon: <CarProfile size={20} />,
			},{
				on: 'click',
				id: 'powerline_modeon',
				action: (e)=>{tc.powerlineMode(e)},
				title: 'Powerlines',
				classes: ['customControl', 'svg', 'disabled'],
				icon: <Lightning size={20} />,
			},
			{
				on: 'click',
				id: 'sensor_modeon',
				title: 'Sensors',
				key: 'l',
				action: (e)=>tc.sensorMode(e),
				classes: ['customControl', 'svg'],
				icon: <MapPinSimple size={20} />,
				/*
				sub: [
					
					{
						on: 'click',
						id: 'sensor_add',
						action: (e)=>tc.addSensor(e),
						title: 'Add sensors',
						classes: ['customControl', 'svg'],
						icon: <Plus size={20} />
					},
					{
						on: 'click',
						id: 'sensor_remove',
						action: (e)=>tc.removeSensor(e),
						title: 'Remove sensors',
						classes: ['customControl', 'svg'],
						icon: <Trash size={20} />
					},
					{
						on: 'click',
						id: 'sensor_modeon',
						action: (e)=>tc.sensorMode(e),
						title: 'Sensors',
						classes: ['customControl', 'svg'],
						icon: <MapPinSimple size={20} />
					}
				]
				*/
				
			},
			{
				on: 'click',
				id: 'turbine_modeon',
				title: 'Turbines',
				key: 't',
				action: (e)=>tc.turbineMode(e),
				classes: ['customControl', 'svg'],
				icon: <svg xmlns="http://www.w3.org/2000/svg" height="20px" viewBox="0 -960 960 960" width="20px" fill="currentColor"><path d="M400-40q0-33 23.5-56.5T480-120v-208q-12-5-22.5-11.5T438-354l-88 56q-14 8-30.5 10.5T286-290l-180-51q-29-8-47.5-32.5T40-429q0-38 26.5-64.5T131-520h301q10-11 22-19t26-13v-137q0-17 6.5-32t18.5-26l137-128q23-22 53.5-25t56.5 13q32 20 41.5 56.5T783-762L624-499q7 12 10.5 26t4.5 29l108 26q16 4 29 14t21 24l91 164q15 27 11 57t-26 52q-27 27-64.5 27T744-107L560-291v171q33 0 56.5 23.5T640-40H400ZM160-760v-80h240v80H160Zm400 71v137q1 0 1.5.5t1.5.5l152-253q2-4 1-8.5t-5-6.5q-3-2-7.5-1t-6.5 3L560-689ZM40-600v-80h200v80H40Zm480 200q17 0 28.5-11.5T560-440q0-17-11.5-28.5T520-480q-17 0-28.5 11.5T480-440q0 17 11.5 28.5T520-400Zm-211 34 93-56q-1-5-1-9v-9H131q-5 0-8 3t-3 8q0 4 2 7t6 4l181 52Zm419 25-114-26q-2 2-4 5t-4 5l195 194q3 3 8 3t8-3q3-3 3.5-6.5T819-177l-91-164ZM120-120v-80h200v80H120Zm400-320Zm43-111ZM401-440Zm205 83Z"/></svg>,
				/*
				sub: [
					
					{
						on: 'click',
						id: 'turbine_add',
						action: (e)=>tc.addTurbine(e),
						title: 'Add turbines',
						classes: ['customControl', 'svg'],
						icon: <Plus size={20} />
					},
					{
						on: 'click',
						id: 'turbine_remove',
						action: (e)=>tc.removeTurbine(e),
						title: 'Remove turbines',
						classes: ['customControl', 'svg'],
						icon: <Trash size={20} />
					},
					{
						on: 'click',
						id: 'turbine_modeon',
						action: (e)=>tc.turbineMode(e),
						title: 'Turbines',
						classes: ['customControl', 'svg'],
						icon: <Windmill size={20} />
					}
				]*/
				
			},
			
			{
				on: 'click',
				id: 'landowner_mode',
				action: (e)=>tc.landownerMode(e),
				title: 'Landowners (Ctrl+L)',
				key: 'l',
				classes: ['customControl', 'svg'],
				icon: <User size={20} />
			},
			{},
			{
				on: 'click',
				id: 'redo',
				action: (e)=>redo(),
				title: 'Redo Action (Ctrl+Y)',
				key: 'y',
				classes: ['customControl', 'svg', 'disabled'],
				icon: <ArrowUUpRight size={20} />
			},
			{
				on: 'click',
				id: 'undo',
				action: (e)=>undo(),
				title: 'Undo action (Ctrl+Z)',
				key: 'z',
				classes: ['customControl', 'svg', 'disabled'],
				icon: <ArrowUUpLeft size={20} />
			},
//			{},
//			{
//				on: 'click',
//				id: 'minimap',
//				action: (e)=>toggleminimap(),
//				title: 'Toggle Minimap',
//				key: 'y',
//				classes: ['customControl', 'minimap', 'disabled'],
//			}
			]
		});
		map.current.controlBar = controlBar;
		//map.current.workModePanel	= new workModePanel({workMode:workMode});
		
		record = new log(map.current, setHasChanges);
		map.current.addControl(Draw, 'bottom-left');
		map.current.addControl(new mapboxgl.ScaleControl(), 'bottom-right');
		
		map.current.addControl(controlBar, 'bottom-left');
		
		tc.landownerModeForce();
		//map.current.addControl(map.current.workModePanel, 'bottom-left');
		
		
		const min = new Minimap({
			parentMap:map.current, 
			center:center, 
			minimized:true,
			togglePosition:'bottomleft'
		});
		map.current.once("load", function () {
			map.current.addControl(new ShowMap(), 'top-right');
			map.current.addControl(min, 'top-right'); // Possible values are bottom-left, bottom-right, top-left, top-right		
			map.current.addControl(new mapboxgl.NavigationControl({showCompass: false}), 'top-right');
			
		});
		
		le = new layerEvents(map.current, {
			setOwner:setOwner
		});
		
		map.current.on('mousemove', 'project-geojson-fill', (e) => {
			//var is set by TubineLayer
			if(map.current.mouseDown)
				return;
			var features = map.current.queryRenderedFeatures(e.point);
			if(mapClickIsDisabled(e.features))
				return;
			
			if (e.features.length > 0) {
				if (hoveredPolygonId !== null) {
					let ownerRef = map.current.getFeatureState({
						source: 'project-geojson',
						id: hoveredPolygonId
					}).ownerRef;
					
					let statusRef = map.current.getFeatureState({
						source: 'project-geojson',
						id: hoveredPolygonId
					}).statusRef;
					
//					ownerRef.forEach((id)=>{
//						if(ownersRef.current[id])
//							ownersRef.current[id].classList.remove('active');
//					});
					
					if(statusesRef.current[statusRef])
						statusesRef.current[statusRef].classList.remove('active');
					
					
					map.current.setFeatureState(
						{ source: 'project-geojson', id: hoveredPolygonId },
						{ hover: false }
					);
					
					//dim all others
					dimAll(false);
				}
				
				highlightPropertyInList(e.features[0].id, true);
				
				hoveredPolygonId = e.features[0].id;
				
				let ownerRef = JSON.parse(e.features[0].properties.ownerid);
				let statusRef = e.features[0].properties.status;
//				ownerRef.forEach((id)=>{
//					if(ownersRef.current[id])
//						ownersRef.current[id].classList.add('active');
//				});
				
				//only update ref if in owner list to avoid flickering
				if(!clickedOwner && (!map.current.selectedFeatures || !map.current.selectedFeatures.length))
					setOwnersRef(ownerRef);

				if(statusesRef.current[statusRef])
					statusesRef.current[statusRef].classList.add('active');
				
				/* I store the reference in the polygon state so it's easyer to retrieve on hover out (queryfeatures was not working properly*/
				
				setFeatureState('project-geojson', [hoveredPolygonId], { hover: true, ownerRef:ownerRef, statusRef:statusRef});
				//dim all others
				dimAll(true, hoveredPolygonId);
				
			}
		});
 
		// When the mouse leaves the state-fill layer, update the feature state of the
		// previously hovered feature.
		map.current.on('mouseleave', 'project-geojson-fill', (e) => {
			if (hoveredPolygonId !== null) {
				
				let ownerRef = map.current.getFeatureState({
					source: 'project-geojson',
					id: hoveredPolygonId
				}).ownerRef;
				
				let statusRef = map.current.getFeatureState({
					source: 'project-geojson',
					id: hoveredPolygonId
				}).statusRef;
				
				
//				ownerRef.forEach((id)=>{
//					if(ownersRef.current[id])
//						ownersRef.current[id].classList.remove('active');
//				});
				//only update ref if in owner list to avoid flickering
				if(!clickedOwner && (!map.current.selectedFeatures || !map.current.selectedFeatures.length))
					setOwnersRef([]);
				
				if(statusesRef.current[statusRef])
					statusesRef.current[statusRef].classList.remove('active');
				
				
				highlightPropertyInList(hoveredPolygonId, false);
				
				setFeatureState('project-geojson', [hoveredPolygonId], { hover: false });
				//dim all others
			}
			dimAll(false);
			hoveredPolygonId = null;
		});
		
		map.current.on('click', ['gl-draw-polygon-fill-inactive.cold', 'gl-draw-polygon-stroke-inactive.cold'], (e) => {
			//console.log(map.current.getStyle().layers);
			var features = map.current.queryRenderedFeatures(e.point);
			if(
				(
					(features && du.isBoundaryFill(features) && !du.isBoundaryStroke(features))	//deselect the boundary (prevent edit when clicking the boundary interior)
					|| 
					!tc.scenario.scenario_id					//don't allow edit scenario 0
				)
				&&
				(
					!['draw_polygon', 'draw_line', 'draw_line_string', 'powerline_mode', 'road_mode'].includes(du.draw.getMode())
				) // if we are currently in draw mode, proceed
			){
				du.draw.changeMode('simple_select');
			}
			
		});
		
		map.current.on('click', 'project-geojson-fill', (e) => {
			var features = map.current.queryRenderedFeatures(e.point);
			if(mapClickIsDisabled(features))
				return;

			if (e.features.length){
				clearFeatureSelection();
				setFeatureState('project-geojson', tc.scenario.properties.features, {selected:false})
				dimAll(true, e.features[0].id);
				setFeatureSelection(e.features[0].id);
				
				const land = tc.scenario.properties.features.find((f)=>f.properties.vindrid == e.features[0].properties.vindrid);
				if(land){
					setLand(land);
					setOwner(null);
				}
			}
		});
		map.current.on('click', (e) => {
			var features = map.current.queryRenderedFeatures(e.point);
			if(!features.length || (features.findIndex((f)=>{return f.layer.id == 'project-geojson-fill'}) == -1)){
				clearFeatureSelection();
				setLand(null);
				setOwner(null);
				dimAll(false);
				setOwnersRef([]);
				
			}
		});
//		map.current.on('draw.create', (e)=>du.handleEvent(e, addToBoundary));
//		map.current.on('draw.delete', (e)=>du.handleEvent(e, updateScenario, tc));
//		map.current.on('draw.update', (e)=>du.handleEvent(e, updateScenario));
//		map.current.on('draw.modechange', (e)=>du.handleModeChange(e));
		//map.current.on('draw.selectionchange', (e)=>du.handleSelectionChange(tc, setPwrRdsPanel, e));
		
		//map.current.on('draw.actionable', (e)=>{console.log("actionable", e)});

	}
	const setFeatureState = (source, ids, state)=>{
		var obj = {};
		
		if(Array.isArray(source)){
			obj.source = source[0];
			obj.sourceLayer = source[1];
		}
		else 
			obj.source = source;
		
		if(!Array.isArray(ids) || !map.current.getSource(obj.source))
			return false;
		
		
		
		
		ids.forEach((f)=>{
			map.current.setFeatureState(
				{ ...obj, ...{id: (typeof f === "object") ? f.id : f }},
				state
			);
		});
	}
	const dimAll = (state, exception)=>{
		//dim all others
//		if(map.current.selectedFeatures && map.current.selectedFeatures.length){
//			return;
//		}
		const d = map.current.currentData;
		d.features.forEach((f)=>{
			setFeatureState('project-geojson', [f.id], { dimmed: (exception == f.id ? !state : state)});
		});
		if(map.current.selectedFeatures && map.current.selectedFeatures.length)
			setFeatureState('project-geojson', map.current.selectedFeatures, { dimmed: false, selected:true});
		
	}
	const setDimState = (features, state)=>{
		setFeatureState('project-geojson', features, { dimmed: state});
	};
	
	const mapClickIsDisabled = (features)=>{
		
			return features[0]
				&& features[0].source
				&& features[0].source.indexOf("mapbox-gl-draw") != -1 // editing a drawn polygon
				&& (features[0].layer.type == "line" || features[0].layer.type == "circle") // currently in boundary edit mode
				|| map.current.disableEvents //currently in add turbine mode
	}


	const clearFeatureSelection = ()=>{
		clickedOwner = null;
		const d = map.current.currentData;

		setFeatureState('project-geojson', d.features, { selected: false});
		
		map.current.selectedFeatures = [];
	}
	const setFeatureSelection = (id)=>{
		
		setFeatureState('project-geojson', [id], { selected: true, dimmed:false});

		map.current.selectedFeatures = [id];	
	}

	const setOwnerByFeature = (featureId) => {
		var ownerId = geoJson[featureId].id;
	}
	
	const updateGeoJsonPropertyState = (id, status) => {
		
		if(geoJson){
			var idx = geoJson.features.findIndex((p)=>p.properties.vindrid == id);
			if(idx){
				geoJson.features[idx].properties.status = status;
				updateGeoJsonLayer(geoJson);
			}
		}
		
	}
	
	const updateGeoJsonLayer = (data) => {
		var a = geoJson;
		if(map.current.getSource('project-geojson')){
			map.current.getSource("project-geojson").setData(data);
		}
	}
	const addGeoJsonLayer = (data, scenario) => {
		
		const props = scenario && Array.isArray(scenario.layers) ? scenario.layers.find((l)=>{return l.id == 'properties'}) : {};
		
		const initialOpacity = isNaN(props?.data?.opacity) ? parseFloat(process.env.REACT_APP_REST_OPACITY) : props.data.opacity;
		
		if (!map.current.getSource('project-geojson') && data && data.features) {
			map.current.addSource("project-geojson", {
				type: "geojson",
				data: data
			});
			var x = map.current.addLayer({
				id: "project-geojson-fill",
				type: "fill",
				source: "project-geojson",
				paint: {
					"fill-opacity": ['case',
						['boolean', ['feature-state', 'invisible'], false],0,
						["all", ['boolean', ['feature-state', 'selected'], false], ['boolean', ['feature-state', 'dimmed'], false]],parseFloat(process.env.REACT_APP_DIMM_OPACITY),
						['boolean', ['feature-state', 'selected'], false],parseFloat(process.env.REACT_APP_ACTIVE_OPACITY),
						['boolean', ['feature-state', 'hover'], false],parseFloat(process.env.REACT_APP_ACTIVE_OPACITY),
						['boolean', ['feature-state', 'dimmed'], false],parseFloat(process.env.REACT_APP_DIMM_OPACITY),
						initialOpacity
					],
					"fill-color": colorProfiles[map.current.projectLayer]
				},
				layout:{
					'visibility': map.current.layerStatus['project-geojson-fill'] ? 'visible' : 'none'
				}
			});
			map.current.addLayer({
				'id': 'owner-numbers',
				'type': 'symbol',
				'source': 'project-geojson',
				'layout': {
					'text-field': '',
					'text-variable-anchor': ['center'],
					'text-radial-offset': 0.5,
					'text-justify': 'auto',
					'visibility': map.current.layerStatus['owner-numbers'] ? 'visible' : 'none'
				},
				'paint': {
					'text-color': ['case',
						['boolean', ['feature-state', 'hover'], false],'#ffffff',
						['boolean', ['feature-state', 'selected'], false],'#ffffff',
						'#000000'
					]	
				}
			});
			map.current.addLayer({
				'id': 'status-numbers',
				'type': 'symbol',
				'source': 'project-geojson',
				'layout': {
					'text-field': '',
					'text-variable-anchor': ['center'],
					'text-radial-offset': 0.5,
					'text-justify': 'auto',
					'visibility': map.current.layerStatus['status-numbers'] ? 'visible' : 'none'
				},
				'paint': {
					'text-color': ['case',
						['boolean', ['feature-state', 'hover'], false],'#000000',
						['boolean', ['feature-state', 'selected'], false],'#000000',
						'#000000'
					]	
				}
			});
			var z = map.current.addLayer({
				id: "project-geojson-stroke",
				type: "line",
				source: "project-geojson",
				paint: {
					"line-opacity": ['case',
						['boolean', ['feature-state', 'invisible'], false],0,
						["all", ['boolean', ['feature-state', 'selected'], false], ['boolean', ['feature-state', 'dimmed'], false]],parseFloat(process.env.REACT_APP_DIMM_OPACITY),
						['boolean', ['feature-state', 'selected'], false],1,
						['boolean', ['feature-state', 'hover'], false],1,
						['boolean', ['feature-state', 'dimmed'], false],parseFloat(process.env.REACT_APP_DIMM_OPACITY),
						initialOpacity
					],
					'line-color':['case',
						['boolean', ['feature-state', 'hover'], false],['get', 'color'],
						['boolean', ['feature-state', 'selected'], false],['get', 'color'],
						'#000000'
					],
					"line-width": ['case',
						['boolean', ['feature-state', 'hover'], false],parseFloat(process.env.REACT_APP_ACTIVE_LINE_WIDTH),
						['boolean', ['feature-state', 'selected'], false],parseFloat(process.env.REACT_APP_ACTIVE_LINE_WIDTH),
						parseFloat(process.env.REACT_APP_REST_LINE_WIDTH)
					],
				},
				layout:{
					'visibility': map.current.layerStatus['project-geojson-stroke'] ? 'visible' : 'none'
				}
			});
			map.current.setCenter(x.getBounds().getCenter());
			map.current.setLayoutProperty("owner-numbers", "text-field", (map.current.projectLayer == 'owners' ? ['get', 'description'] : ''));
			map.current.setLayoutProperty("status-numbers", "text-field", (map.current.projectLayer == 'status' ? ['get', 'statusDescription'] : ''));
			//move draw layer to top 
			//didn't manage to get fill-sort-key to work with the draw plugin and this way works fine
			//gl-draw-polygon-fill-inactive.cold is the first layer of the fdraw stack, so we just have to put geojson layers under that one
			du.stackProjectLayer();
		}

	}
	
	const changeProjectLayer = (e) => {
	
		var layer = e.target.checked ? projectLayers[0] : projectLayers[1];

		clickedOwner = null;
		setProjectLayer(layer);
		map.current.projectLayer = layer.value;
		if(colorProfiles[layer.value]){
			map.current.setPaintProperty("project-geojson-fill", 'fill-color', colorProfiles[layer.value] );
			map.current.setLayoutProperty("owner-numbers", "text-field", (map.current.projectLayer == 'owners' ? ['get', 'description'] : ''));
			map.current.setLayoutProperty("status-numbers", "text-field", (map.current.projectLayer == 'status' ? ['get', 'statusDescription'] : ''));
		}

	}
	const changeWorkMode = (wm, proj) => {
		

		const newWorkmode			= wmConfig.get(wm, wmConfig.country);
		newWorkmode.obj.map			= map.current;
		newWorkmode.obj.refresh		= setRefresh;
		newWorkmode.obj.setOwner	= setOwner;
		newWorkmode.obj.setOwners	= setOwners;
		newWorkmode.obj.setLand		= setLand;
		newWorkmode.obj.scenario	= scenario;
		newWorkmode.obj.tc			= tc;
		newWorkmode.obj.setEditOwner= setEditOwner;
		newWorkmode.obj.context		= context;
		
		if(workMode.obj.exitWorkmode)
			workMode.obj.exitWorkmode();
		
		if(newWorkmode.obj.setEvents)
			newWorkmode.obj.setEvents();
		
		tc.workMode = newWorkmode;
		setWorkMode(newWorkmode);
		showScenario(context.getters.selectedScenario, params.id, null, null, wm);
		infoLayerPanel.current.handleWorkMode(newWorkmode);
	}
	
	const changeBaseLayer = (layer, onDone, scenario) => {
		
		setSelectedBaseLayer({...{label:mapStyles[layer.value].label}, ...layer});
		
		map.current.currentStyle = mapStyles[layer.value];
		
		map.current.setStyle(mapStyles[layer.value].value, {diff:false});
		
		map.current.once('style.load', ()=>{

			if(workMode.value != '')
				addGeoJsonLayer(geoJson, scenario);
//			if(scenario){
//				du.drawEllipses(scenario.wtgs, projectData);
//				du.drawCircles(scenario);
//				du.drawRoads(scenario, tc)
//				du.drawPowerLines(scenario, tc)
//			}
			if(onDone instanceof Function)
				onDone();
			
			redrawInfoLayers();
			

			
			//du.syncLayerOpacity();
		});
	}


	/* highlight and dehighlight are responsible for highlighting the plot on the map, when mousing over the owner in the list*/
	const highLightMap = (owner, matchFunction) => {
		
		var ids = matchFunction(owner);
		
		setFeatureState('project-geojson', ids, {hover: true});
		//dim all others
		dimAll(true);
	}
	const togglePlot = (e, owner, matchFunction, force) => {
		
		var ids = matchFunction(owner);
		var invisible = force != null ? force :	e.target.classList.contains("opacity-25");
		
		var idx = owners.findIndex((o)=>o.id==owner)

			
		ids.forEach((id)=>{

			setFeatureState('project-geojson', [id], {invisible: !invisible});
			setOwners((owners)=>{owners[idx].invisible = !invisible; return owners});
		});
		e.target.classList[!invisible ? "add":"remove"]("opacity-25");
	}
	
	const togglePlotAll = (e, matchFunction)=>{
		var invisible = e.target.classList.contains("opacity-25");
		
		var owners = document.querySelectorAll(".project-landowners .rdt_TableRow svg");
		
		owners.forEach((o)=>{
			togglePlot({target:o}, o.dataset.id, matchFunction, invisible);
			
		});
		
		//toggle orphan plots
		setFeatureState('project-geojson', getOrphanFeatures(), {invisible: !invisible});
		
		e.target.classList[!invisible ? "add":"remove"]("opacity-25");
	}
	
	const deHighLightMap = (owner, matchFunction) => {
		
		setFeatureState('project-geojson', matchFunction(owner), {hover: false});
		
		//dim all others
		dimAll(false);
	}

	const handleEditProject = (project) => {
		
		setSettingsDialog({open:true, project:structuredClone(project)});
	}
	const handleSaveProject = (proj) => {
		
		var newData = {...project, ...proj};
				
	
		setProject(newData);
		
		
	}
	const handleOwnerClick = (owner) => {
		handleOwnerListClick(owner);
	}
	const handleOwnerListClick = (row) => {
		
		const ids = getFeatureIdsByOwnerId(row.id);
		if(ids.length){
			setFeatureSelection(ids);
			setFeatureState('project-geojson', ids, { selected: true});
			
			if(row.unknown){
				var land = map.current.currentData.features.find((l)=>{return l.properties.ownerid.includes(row.id)});
				setLand(land);
				return;
			}
			else				
				setOwner(owners.find(item => item.id == row.id)); 
		}
		else //case is an owner from cadastral layer
			setOwner(row); 
		
		clickedOwner = row.id;
	}
	const handleOwnerPropertyClick = (property, otherFeatures) => {
		
		setOwner(null);
		setLand(property);
		
		
		//timeout is necessary because there is a mouseleave event comming from the owner panel, that sets featuers state 
		setTimeout(()=>{
			setFeatureState('project-geojson', scenario.properties.features, { selected: false, dimmed:true, hover:false});
			setFeatureSelection(property.id);
		}, 100)
		
	}
	const getFeatureIdsByOwnerId = (ownerId) => {
		
		let ids = [];
		
		if(!geoJson.features.length)
			return ids;
		
		map.current.currentData.features.forEach((item, key)=>{
			if(item.properties.ownerid.includes(isNaN(ownerId) ? ownerId : parseInt(ownerId)))
				ids.push(item.id);
		});
		return ids;
	}
	const getOrphanFeatures = (ownerId) => {
		
		let ids = [];
		
		if(!geoJson.features.length)
			return ids;
		
		geoJson.features.forEach((item, key)=>{
			if(!item.properties.ownerid.length)
				ids.push(item.id);
		});
		return ids;
	}
	const getFeatureIdsByStatus = (status) => {
		
		let ids = [];
		
		if(!geoJson.features || !geoJson.features.length)
			return ids;
		
		geoJson.features.forEach((item, key)=>{
			if(item.properties.status == status)
				ids.push(key);
		});
		return ids;
	}

	const toggleProjectLayer = (e, toggleFunction) => {
		
		if(toggleFunction){
			//this function can disable layers, or return a comma separated list of layers to be disabled
			var layer = toggleFunction(e.target.checked);
			
			if(typeof layer == "boolean")
				return;
		}
		else
			var layer = e.target.dataset.layer.split(",");
		var show = e.target.checked;
		
		layer.forEach((l)=>{
			map.current.setLayoutProperty(
				l.trim(),
				'visibility',
				(show ? 'visible' : 'none')
			);
			map.current.layerStatus[l] = show;			
		});
	}

	//we call redraw when changing baselayer
	const redrawInfoLayers = () => {
		if(infoLayerPanel.current){
			infoLayerPanel.current.redraw();
		}
	}
	
	
	const showErrors = () => {
		if(errors.length) 
			return (<Alert variant="warning">{errors.map((m, k)=>{return <div key={k}>{m}</div>})}</Alert>) 
	}
	
	const showHasChanges = (e, onAfter) => {
		
		if(hasChanges){
			if(e)
				e.preventDefault();
			
			tc.scenario.modified = 0;
			
			//set to 0 to avoid loop, this function will be called after dialod
			setSaveScenario({
				open:true,
				scenario:scenario,
				user:user,
				prompt:true,
				btnCloseText:"Don't Save", 
				btnSaveText:"Save and proceed", 
				text:"You have unsaved changes, would you like to save your scenario?",
				icon:{
					class:'ri-information-line',
					color:'info'
				},
				onAfter: (onAfter ? onAfter : ()=>{window.location.href=e.target.href})
			});			
		}
		

		
	}
	
	const showScenario = (selected, resolvedScenario, keepHistory, usr, wm) => {
		
		du.reset();
		var self = this;
		setOwner(null);
		setLand(null);
		//check if changes have been made to the current scenario and offer to save
		if(selected && tc.scenario && tc.scenario.modified){
			showHasChanges(null, ()=>{showScenario(selected)});
			return;
		}
		//have to 
		usr = usr ? usr : user;
		//check if first load
		if(resolvedScenario && resolvedScenario.name){
			var tasks = [Promise.resolve(resolvedScenario)];
		}
		else {
			setLoaded(false);
			var tasks = [
				vindrApi.getScenario(params.id, selected.value, null, (wm ? wm : (workMode.value ? workMode.value : null))),
				vindrApi.getScenarioAEP(params.id, selected.value ? selected.value : 0),
				vindrApi.getTurbineTypes(),
				vindrApi.getTurbineHeights(),
				vindrApi.getAnnotations(params.id, selected.value ? selected.value : 0),
			];
		}
		//get the selected scenario
		Promise.all(tasks).then((result)=>{

			var newScenario = result[0];
			
			if(result[1] && result[2] && result[3]) {
				newScenario.aep = result[1];
				newScenario.turbine_types = result[2];
				newScenario.hub_heights = result[3];
				newScenario.annotations = result[4];
				
				if(!newScenario.sensors)
					newScenario.sensors = [];
			}
			
			//update project data with real ellipses sizes (necessary for undo/redo)
			if(newScenario.wtgSettings.turbineType && newScenario.turbine_types.length){
				
				const x = newScenario.turbine_types.find((t)=>{return t.turbine_type == newScenario.wtgSettings.turbineType});
				
				if(x){
					projectData.short_turbine_radius = x.short_turbine_radius;
					projectData.long_turbine_radius = x.long_turbine_radius;
				}
			}
			
		
			
			//if new scenario loaded, then show noew plots and owners
			if(newScenario){
				var owners = newScenario.landowners;
				var geodata = newScenario.properties;
				processOwnersAndLands(owners, geodata);
				map.current.currentData = geodata;
				setOwners(owners);
				ownersPersist = owners;
				geoJson = geodata;
				updateGeoJsonLayer(geoJson);
				
				ownersPersist = owners;
			}
			
			if(!newScenario.circles)
				newScenario.circles = [];

			if(
				usr && usr.settings &&
				usr.settings.turbineStyles.circles && 
				projectData.turbine_circles && 
				projectData.turbine_circles.length
			){
				projectData.turbine_circles.forEach((c)=>{
					c.circleid = randomId();
					c.default = true;
					newScenario.circles.push(c)
				});
			}
			
			if(selected){
				setSelectedScenario(selected);
			}

			setProject((p)=>{
				if(owners)
					p.numLandowners	= owners.length;
				if(geodata)
					p.numProperties	= geodata.features ? geodata.features.length : 0;
				p.size			= newScenario.stats.size;
				p.numTurbines	= newScenario.stats.numTurbines;
				
				return p;
			});
			
			
			//du.setBoundary(newScenario, tc);
			//du.drawTurbines(newScenario, tc);
			
			if(params.id && !newScenario.wind_direction)
				//vindrApi.getProject(params.id).then(function(projectData){
				newScenario.wind_direction = projectData.wind_direction;
			
			tc.setScenario(newScenario, setScenario);
			if(tc.handler)
				tc.handler.display();
			
			redrawInfoLayers();
			
//			du.drawEllipses(newScenario.wtgs, projectData);
//			du.drawCircles(newScenario, tc);
//			du.drawPhotos(newScenario, setPanoramicImage, panoramicRef);
//			du.drawPowerLines(newScenario, tc);
//			du.drawRoads(newScenario, tc);
			
			
				//});
			setPageSubTitle(newScenario.name);
			t3d.setScenario(newScenario);

			setUrlParam("scenarioid", newScenario.scenario_id);
			if(versionid && resolvedScenario)
				setUrlParam("versionid", versionid);
			else{
				setUrlParam("versionid");
				versionid = 0;
			}
			setUrlParam("workmode", wm);
			
			const ta = new ToolAnnotation(tc);
			ta.drawAnnotations();
			
			//if show scenario comes from dropdown selectiom reset history
			if(!keepHistory)
				record.reset(newScenario);
			
			map.current.fire("scenario.updated");
			
			setLoaded(true);
		}).catch((e)=>{
			console.log(e);
			
			setLoaded(true);
			setErrors(p => [...p, 'Error fetching data']); //add this error to previous errors
		});;
		
		
		//remove layers and turbines from current map
		//add project boundary and turbines and ellipses
	}
	const updateScenario = (params) => {
		
		//check for new boundary and update; Set modify flag for later
		if(params.boundary && params.boundary.geometry){
			
			
			
			tc.scenario.boundary.geometry = params.boundary.geometry;
			tc.scenario.modified = 1;
			record.add(tc.scenario);
			//console.log();
		}
	}
	const addToBoundary = (polygon) => {

		//check for new boundary and update; Set modify flag for later
		if(polygon && polygon.coordinates){
			
			tc.scenario.boundary.geometry.coordinates.push(polygon.coordinates);
			
			tc.scenario.modified = 1;
			record.add(tc.scenario);
			//console.log();
			tc.infoLayers.current.resetSystemLayer("boundary");
			du.draw.delete('added_boundary');
		}
	}
	const replaceBoundary = (polygon) => {


		//check for new boundary and update; Set modify flag for later
		if(polygon && polygon.features){
			
			tc.scenario.boundary.geometry = polygon.features[0].geometry;
			
			tc.scenario.modified = 1;
			record.add(tc.scenario);
			//console.log();
			tc.infoLayers.current.resetSystemLayer("boundary");
			//du.draw.delete('added_boundary');
		}
	}
	const replaceRoads = (polygon) => {

		var s = {...tc.scenario};
		//mark current roads for deletion
		s.roads.forEach((r)=>{
			delete r.geometry;
			
		});
		

		//check for new boundary and update; Set modify flag for later
		if(polygon && polygon.features){
			
				polygon.features.forEach((f)=>{
					
					if(f.geometry.type == 'LineString'){
						var nrd = {...f};
						if(!f.properties.road_id)
							nrd.properties = {tempid : Math.floor(1000000 + Math.random() * 10000000)};

						s.roads.push(nrd);
					}
					else if(f.geometry.type == 'MultiLineString'){

						f.geometry.coordinates.forEach((c)=>{

							var nrd = {...f};
							if(!f.properties.road_id)
								nrd.properties = {tempid : Math.floor(1000000 + Math.random() * 10000000)};
							nrd.geometry = {
								coordinates: c,
								type: 'LineString'
							};
							s.roads.push(nrd);

						});
					}


				});
			
			//issue exit command to refresh viewport (weird bug not deleting the pl linestring
			
			tc.scenario.modified = 1;
			s.modified = 1;
			tc.infoLayers.current.resetSystemLayer("roads");
			tc.record().add(s);
			tc.setScenario(s);
			//du.draw.delete('added_boundary');
		}
	}
	const replacePowerlines = (polygon) => {

		var s = {...tc.scenario};
		//mark current powerlines for deletion
		s.powerlines.forEach((r)=>{
			delete r.geometry;

		});

		//check for new boundary and update; Set modify flag for later
		if(polygon && polygon.features){

			polygon.features.forEach((f)=>{

				if(f.geometry.type == 'LineString'){
					var nrd = {...f};
					if(!f.properties.powerline_id)
						nrd.properties = {tempid : Math.floor(1000000 + Math.random() * 10000000)};
		
					s.powerlines.push(nrd);
				}
				else if(f.geometry.type == 'MultiLineString'){

					f.geometry.coordinates.forEach((c)=>{

						var nrd = {...f};
						if(!f.properties.powerline_id)
						nrd.properties = {tempid : Math.floor(1000000 + Math.random() * 10000000)};
						nrd.geometry = {
							coordinates: c,
							type: 'LineString'
						};
						s.powerlines.push(nrd);

					});
				}


			});

			
			tc.scenario.modified = 1;
			s.modified = 1;
			tc.infoLayers.current.resetSystemLayer("powerlines");
			tc.record().add(s);
			tc.setScenario(s);
			
			//du.draw.delete('added_boundary');
		}
	}
	const replaceTurbines = (polygon) => {

		var s = {...tc.scenario};
		
		
		//mark current roads for deletion
		s.wtgs.forEach((r)=>{
			delete r.geometry;
			
		});
		
		//check for new boundary and update; Set modify flag for later
		if(polygon && polygon.features){
			
				polygon.features.forEach((f)=>{
					
					f.geometry.coordinates.forEach((c)=>{

						var newTurbine = {
							"geometry": {
							  "coordinates": c,
							  "type": "Point"
							},
							"turbineid": 'temp_'+Math.random().toString(36).substr(2, 9),
							"name": "Turbine"
						}

						s.wtgs.push(newTurbine);
						
					});
					
				});

			tc.infoLayers.current.resetSystemLayer("turbines");
			tc.infoLayers.current.resetSystemLayer("ellipses");
			
			if(s.wtgSettings.circles && s.wtgSettings.circles.length){
				du.clearCircles(s);
				du.drawCircles(s);
			}
			//issue exit command to refresh viewport (weird bug not deleting the pl linestring
			

			tc.scenario.modified = 1;
			s.modified = 1;
			
			tc.setScenario(s);
			tc.record().add(s);
			
			//du.draw.delete('added_boundary');
		}
	}
	
	const saveButton = () => {
		
		
			return (<button onClick={save} className={"btn btn-"+(hasChanges ? "":"outline-")+"primary "  +(tc && tc?.scenario?.kinks ? ' disabled ' : '')}>Save changes</button>);
		
		
	}
	const saveLayerConfig = (payload) => {
		vindrApi.saveLayerConfig(params.id, scenario.scenario_id, {layers: payload});
		
	}
	const showOpacityControl = (e)=>{
	
		var input = e.currentTarget.querySelector("INPUT");
		if(input && input.checked && input.dataset && input.dataset.layer){
			du.currentSelectedLayer = input.dataset;
			du.currentLayerLegend = e.currentTarget.dataset.legend;
			show({
				event:e
			});
			
			du.setRangeOpacity();
			du.setOpLegend();
			
		}
	
	}
	const showStatuses = () => {
		
		if(map.current && map.current.projectLayer == "status"){
			var statusList = propertyStatusColor.getList();
			const lines = statusList.map((name, key) => {
				return (
					<ListGroup.Item 
						as="li" 
						onMouseEnter={(e)=>{highLightMap(e.target.dataset.status, getFeatureIdsByStatus);}} 
						onMouseLeave={(e)=>{deHighLightMap(e.target.dataset.status, getFeatureIdsByStatus);}} 
						key={key}
						data-status={name}
						ref={el => statusesRef.current[name] = el}
					>
						<div className="badge-dot" style={{backgroundColor:propertyStatusColor.getColor(name)}} /> 
						{name}
					</ListGroup.Item>
				)
			})
		
			
			return (<ListGroup as="ol" numbered	className={"project-statuses "}>{lines}</ListGroup>);
		}
		
	}

	const landOwners = () => {
		
		if(owner || (land && land.id || workMode.value == '') )
			return;
		if(owners.length){
			
			//owners.map((owner, key) => {owner.number = key+1});
				let regex = new RegExp(norm(filterText), "i");
				
				const filteredItems = owners.filter(
					(item) => {
						return (item.fullName && norm(item.fullName).match(regex, "i")) || (item.properties.findIndex((p)=>{return p.id.match(regex)}) > -1);
					}
					
				);
			if(filterText){
				clearFeatureSelection();
				var ids = filteredItems.map((i)=>{
					return getFeatureIdsByOwnerId(i.id);
				});
				
				
				map.current.selectedFeatures = ids.flat(Infinity);
				dimAll(true);
			}
			
			const unknowns = owners.filter((o)=>{return o.unknown;});
			
			filteredItems.forEach((row)=>{
				row.affectedArea = row.properties.map((a)=>{return a.area}).reduce((partialSum, a) => partialSum + a, 0);
			});

			const lines2 = (
				<div className={"project-landowners "+ (owner ? 'd-none' : '')}>
					

					<OwnerFetcher workMode={workMode} context={context} unknowns={unknowns} />
					
					
					
					<DataTableFilter value={filterText} onChange={(value)=>{clearFeatureSelection(); dimAll(false); setFilterText(value);}} />
					<div className="scroll">
						<DataTable
							data={filteredItems}
							columns={[
								...[
									{
										name:<Eye onClick={(e)=>{togglePlotAll(e, getFeatureIdsByOwnerId)}} size={16} />,
										id:'userid',
										selector: row => row.userid,
										format: (row) =>	(<Eye onClick={(e)=>{togglePlot(e, row.id, getFeatureIdsByOwnerId)}} id={"owner_"+row.id} data-id={row.id}  className={""+(row.invisible ? 'opacity-25' : '')} size={16} />),
										width:"28px",
										style: {
											padding: '0',
										}
									},
									{
										name:'#',
										id:'number',
										selector: row => row.number,
										sortable: true,
										width:"24px",
										right: "true",
										style: {
											minWidth:"21px !important",
											justifyContent:"center"
										}

									},
									{
										name:'Name',
										id:'name',
										selector: row => row.fullName,
										sortable:true,
										format: (row) =>	(<div data-tag="allowRowEvents"><div data-tag="allowRowEvents" className="badge-dot" style={{backgroundColor:row.color}} /> {row.fullName}</div>),
										width:"100%",
									}
								],
								...workMode.columns,
								...workMode.obj.contextMenu()
							]}
							customStyles={{
								headCells:{
									style: {
										padding:'.5rem .3rem',
										minWidth:'0px !important',
										boxSizing:'content-box',
										fontWeight:'bold'
									}
								},
								cells:{
									style: {
										padding:'.5rem .3rem',
										minWidth:'0px !important',
										boxSizing:'content-box',
										fontSize: 'var(--bs-body-font-size);',
										color:'var(--bs-body-color)',
										'&:last-child':{paddingRight:'1rem'}
									}
								},
								rows:{
									style: {
										minHeight:"0",
									},
									selectedHighlightStyle:{
										backgroundColor:'red'
									}
								}
							}}
							onRowMouseEnter={(row, e)=>{if(filterText) return; highLightMap(row.id, getFeatureIdsByOwnerId);}}
							onRowMouseLeave={(row, e)=>{if(filterText) return; deHighLightMap(row.id, getFeatureIdsByOwnerId);}}
							onRowClicked={(row)=>{handleOwnerListClick(row);}}
							selectableRowSelected={(row)=>{return ownersRef.includes(row.id)}}
							highlightOnHover
							selectableRowsHighlight
							pointerOnHover
							defaultSortFieldId={ownersSort.column}
							defaultSortAsc={ownersSort.direction == 'asc'}
							onSort={(c,d)=>{ownersSort.column = c.id; ownersSort.direction=d;}}
							sortIcon=<i className="ri-expand-up-down-line"></i>
						/>
						{workMode.tableFooter(filteredItems)}
					</div>
				</div>
			);
			
			return lines2;
		}
		else
			return <div className={"project-landowners "+ (owner ? 'd-none' : '')}></div>
	}
	const lands = () => {
		
		if(!workMode || workMode.value!='')
			return;
	
		workMode.obj.getData(map.current);

		
		if(workMode.obj.data.length){
			
			
			const filteredItems = workMode.obj.data.filter(
				item => (
					item.vindrid && item.vindrid.normalize('NFD').replace(/[\u0300-\u036f]/g, "").match(new RegExp(filterText.normalize('NFD').replace(/[\u0300-\u036f]/g, ""), "i"))
					||
					item.propertyid && item.propertyid.normalize('NFD').replace(/[\u0300-\u036f]/g, "").match(new RegExp(filterText.normalize('NFD').replace(/[\u0300-\u036f]/g, ""), "i"))
					||
					item.fullName && item.fullName.normalize('NFD').replace(/[\u0300-\u036f]/g, "").match(new RegExp(filterText.normalize('NFD').replace(/[\u0300-\u036f]/g, ""), "i"))
				)

			);	
			if(filterText)
				workMode.obj.highlightResults(filteredItems);

			const lines2 = (
				<div className={"project-landowners all"+ (owner ? 'd-none' : '')}>
			

					
					<DataTableFilter value={filterText} onChange={(value)=>{workMode.obj.clear(); setFilterText(value);}} />
					<div className="scroll">
						<DataTable
							data={filteredItems}
							columns={[
								...[	
									
									{
										name:'Owner',
										id:'fullName',
										selector: row => ( <div data-tag="allowRowEvents"><div data-tag="allowRowEvents" className="badge-dot" style={{backgroundColor:row.color}} /> { row.fullName }</div>),
										sortable:true,
										//minWidth:"160px !important",
										//maxWidth:"160px !important",
									},
									{
										name:'Property ID',
										id:'id',
										selector: row => row.id,
										sortable:true,
										format: (row) => row.id,
										maxWidth:"120px !important",
									},
								],
								...workMode.obj.contextMenu()
								
							]}
							customStyles={{
								headCells:{
									style: {
										padding:'.5rem .3rem',
										minWidth:'0px !important',
										boxSizing:'content-box',
										fontWeight:'bold'
									}
								},
								cells:{
									style: {
										padding:'.5rem .3rem',
										minWidth:'0px !important',
										boxSizing:'content-box',
										fontSize: 'var(--bs-body-font-size);',
										color:'var(--bs-body-color)',
										'&:last-child':{paddingRight:'1rem'}
									}
								},
								rows:{
									style: {
										minHeight:"0",
									},
									selectedHighlightStyle:{
										backgroundColor:'red'
									}
								}
							}}
							onRowMouseEnter={(row, e)=>{workMode.obj.handleListHover(row);}}
							onRowMouseLeave={(row, e)=>{workMode.obj.handleListLeave(row);}}
							onRowClicked={(row)=>{workMode.obj.handleListClick(row);}}
							selectableRowSelected={(row)=>{return workMode.obj.isHoveredBy(row.id)}}
							highlightOnHover
							selectableRowsHighlight
							pointerOnHover
							defaultSortFieldId={workMode.obj.defaultListSort.column}
							defaultSortAsc={workMode.obj.defaultListSort.direction == 'asc'}
							onSort={(c,d)=>{workMode.obj.defaultListSort.column = c.id; workMode.obj.defaultListSort.direction=d;}}
							sortIcon=<i className="ri-expand-up-down-line"></i>
						/>
					</div>
				</div>
			);
			
			return lines2;
		}
		else if (!land && !owner) {
			return (<div className="alert alert-branded m-3"><Info size={16} /> <b>Info:</b> Please zoom in to see the properties</div>)
		}
		
	}
	const landOwner = () => {
		
		if(!owner)
			return false;
		
		
		
		
		var properties = [];
		var clickedIndex = -1;
		var clicked = [];
		const ExpandedComponent = ({ data }) => {
			
		
			var property = scenario.properties.features.find((f)=>f.properties.vindrid == data.id);
			
			const propOwners = property.properties.ownerid;
			
			return (
			<div className="expandable">

				{!!data.name &&
				<Row className="expanded-info">
					<Col xs="12">
						<i className="ri-building-4-line mr-2"></i>
						<b>Name: </b>
						{data.name}
					</Col>
				</Row>
				}
				{propOwners.length>1 &&
				<Row className="expanded-info">
					<Col xs="12">
						<i className="ri-information-2-line text-warning mr-2"></i>
						This property has multiple owners
					</Col>
				</Row>
				}
				{!!data.id &&
				<Row className="expanded-info">
					<Col xs="12">
						<i className="ri-circle-fill mr-2" style={{color:property.properties.color}}></i>

						<button className="btn btn-text p-0" onClick={(e)=>{setLand(property)}}>
							<b>ID: </b>
							{data.id }
						</button>
					</Col>
				</Row>
				}
			</div>
			)
		};


		if(owner.id){

			
			if(owner.properties && owner.properties.length) {
				clickedIndex = owner.properties.findIndex((i)=>i.id == owner.clickedProperty);
				clicked = owner.properties.slice(clickedIndex, clickedIndex+1);
				properties = owner.properties;
				var ownerVindrIds = properties.map((p)=>{return p.id});
				var ownerFeatures = scenario.properties.features.filter((f)=>{return ownerVindrIds.includes(f.properties.vindrid)});
				
				setFeatureState('project-geojson', ownerFeatures, {dimmed:false, selected:true});
			}
			return (
				
					<div className={"project-landowner "}>
						<div className="title">
							<i className={"ri-circle-fill me-2 "+(changeColor.open ? 'active' : '')} onClick={(e)=>{workMode.obj.openChangeColorDialog(owner)}} style={{color:owner.color}}></i> {owner.companyName ?	owner.companyName : owner.fullName}
							<span onClick={(e)=>{

								//e.target.closest(".project-landowner-wrp").classList.add("fold");
								//setTimeout(()=>{
									setOwner(null); 
									clearFeatureSelection(); 
									dimAll(false);
									workMode.obj.clear();
								//},500);

							}} 
							className="btn btn-close alt btn-sm float-end"><X size={16} /></span>
						</div>
						<div className="owner-body">
							<div className="separator">
								<span>Contact info</span>
								<span className="ms-auto btn  p7 " onClick={()=>{setEditOwner({open:true, owner:owner, onSave:handleSaveOwner}); clearFeatureSelection();}} title="Edit"><PencilSimple size={16} /></span>
							</div>
							<div className="content">

								{!!owner.email &&
								<Row className="basic-info mb-2">
									<Col xs="5">
										<i className="ri-mail-line mr-2"></i>
										<span>Email</span>
									</Col>
									<Col xs="7 text-end">
										{owner.email}
									</Col>
								</Row>
								}
								{!!owner.phone &&
								<Row className="basic-info mb-2">
									<Col xs="5">
										<i className="ri-phone-line"></i>
										<span>Phone</span>
									</Col>
									<Col xs="7 text-end">
										{owner.phone}
									</Col>
								</Row>
								}
								{!!owner.identifier &&
								<Row className="basic-info mb-2">
									<Col xs="5">
										<i className="ri-key-2-fill"></i>
										<span>Identifier</span>
									</Col>
									<Col xs="7 text-end">
										{owner.identifier}
									</Col>
								</Row>
								}
								<Row className="basic-info">
									<Col xs="5">
										<i className="ri-home-4-line"></i>
										<span>Address</span>
									</Col>

									<Col xs="7 text-end">
										{owner.address ? owner.address : (owner.street ? owner.street : '')}
										{owner.zipcode ? (<span>,<br />{owner.zipcode}</span>) : ''}
										{owner.city ? ' '+ owner.city : ''}
									</Col>
								</Row>
							</div>


							{!!(properties.length) && <>
								<div className="separator">
									<span>Properties</span>
								</div>
								<div className="content">
								{
									properties.map((row)=>{
										
										const vindrid = row.vindrid ?? row.id;
										
										var property = scenario.properties.features.find((f)=>f.properties.vindrid == vindrid);
										
										if(!property)
											return;
										const others = ownerFeatures.filter((f)=>{return f.properties.vindrid != vindrid});
										return (
											<Row className="expanded-info pb-2" onMouseEnter={(e)=>{setDimState(others, true)}} onMouseLeave={(e)=>{setDimState(others, false)}} >
												<Col xs="12" className={"property_"+property.vindrid}>
													<i className="ri-circle-fill me-2" style={{color:property.properties.color}}></i>

													<button className="btn btn-text p-0" onClick={(e)=>{handleOwnerPropertyClick(property, others)}}>
														<b>ID: </b>
														{vindrid}
													</button>
													{workMode.value != 'compensation' && 
														<SelectWrp onChange={changePropertyState} selected={row.status} options={propertyStatusColor.asOptions()} extraParam={owner.id} propertyId={vindrid}	/>
													}
												</Col>
											</Row>
									)})
								}

								</div>	
								</>
							}
							<div className="separator">
								<span>Dialog</span>
							</div>
							<div className="content">

								<DialogDialog owner={owner} onAdd={handleAddDialog} projectid={params.id} user={user} onClose={()=>{}} />

								{!!(owner.dialogs && owner.dialogs.length) && 
									<Row className="owner-dialog my-3 pt-3">

										{

											owner.dialogs.map((dialog, j)=>{
												var d = formatDate(dialog.timestamp, 'natural');


												return (
													<React.Fragment key={j}>
														<div className="msg-wrp">
															<div className="msg-header mb-2">
																<span>{dialog.username} </span>
																<DoNowButton 
																	key={j}
																	onClick={()=>{
																		return vindrApi.deleteDialog(dialog.id);
																	}}
																	variant="ms-auto"
																	btnClassName="delete"
																	variantSuccess=" text-success"
																	textSuccess=""
																	onFinish={()=>{handleDeleteDialog(dialog.id)}}
																	text={''}
																	finishTimeout={1000}
																	iconIdle={'ri-delete-bin-6-line'}
																>
																</DoNowButton>
															</div>
															<div className="msg-body">
																



																{dialog.text}
															</div>
															<div className="msg-footer">
																<small>{dialog.type}, {d}</small>
															</div>
														</div>
													</React.Fragment>
												)
											})
										}

									</Row> 
								}


							</div>


						</div>

				</div>
			
			)
		}
	}
	
	const landInfo = () => {
		
		
		if(land && land.id !== false)
			return <PanelLand 
						land={land} 
						idProject={params.id} 
						tc={tc} 
						setLand={setLand} 
						projectData={projectData} 
						setOwners={setOwners} 
						setOwner={(o)=>{handleOwnerClick(o);}}
						setEditOwner={setEditOwner}
						changePropertyOwner={changePropertyOwner} 
						changePropertyState={changePropertyState}
						ownersGlobal={ownersPersist} 
						clear={clearFeatureSelection} 
						setDisassocProp={setDisassocProp} 
						clearAll={dimAll} 
						context={context}
						user={user}
						workMode={workMode}
					/>
	}

	const toggleSubMenu = (e) => {
		e.preventDefault();

		let parent = document.querySelector("#project-filters");
		parent.classList.toggle('show');
		e.target.classList.toggle('show');
	}

	const scenarioSidebar = () =>{
		if(geoJson	&& scenario){
			return (
				<ScenarioSwitch 
					scenario={scenario}
					project={project}
					scenarios={scenarios}
					selectedScenario={selectedScenario}
					onSelectScenario={showScenario}
					onDelete={delScenario}
					onClose={showHasChanges}
					onSave={save}
					onDownload={download}
					onVersions={()=>{setVersions({open:true, scenario:scenario});}}
					onViewNotes={()=>{setViewNotes({open:true});}}
					versionid={versionid}
					onRequestLandOwners={()=>{setRequestLandOwners({open:true});}}
					onSetMain={()=>{setSetMain({open:true, scenario:scenario, user:user});}}
					onTerminate={()=>{setTerminate({open:true});}}
					onDuplicate={duplicateScenario}
					onReplace={replaceBoundary}
					onReplaceRoads={replaceRoads}
					onReplacePowerlines={replacePowerlines}
					onReplaceTurbines={replaceTurbines}
					hasChanges={hasChanges}
					user={user}
					active={scenario.modified}
				/>
			)
		}
	}
	const ProjectSidebar = () => {
		

		
		if(geoJson	&& scenario){
			return (
				<React.Fragment>
				
					<div className="nav-group project-panel py-0 show">
						
						<div id="layers" className="layer-section">
							<InfoLayers ref={infoLayerPanel} context={context} scenario={scenario} user={user} project={project} map={map} workMode={workMode} du={du} onChange={saveLayerConfig} />


						</div>
						

						<Menu id="layer_opacity_control">
							<Item>{dialogOpacity()}</Item>
						</Menu>
					</div>
				</React.Fragment>
			);
		}	
	}
	const dialog3d = ()=>{
		if(t3d)
			return t3d.dialog();
	}
	const dialogDrawing = ()=>{
		if(du)
			return du.drawOptionsPanel();
	}
	const dialogOpacity = ()=>{
		if(du)
			return du.drawOpacityPanel();
	}

	const panoramicPanel = () => {
		if(du)
			return (
			<ReactPhotoSphereViewer 
				ref={panoramicRef} 
				onPositionChange={(a, b, c)=>{du.alignCamera(b);}} 
				navbar={
					['zoom', 'fullscreen', 
						{
							content: '<i className="ri-close-large-line"></i>',
							onClick: (viewer) => {
								du.closePhotos(setPanoramicImage);

							},
						}				
					]
				} 
				defaultYaw="0" 
				defaultZoomLvl="10" 
				src="" 
				height={'100vh'}>
			</ReactPhotoSphereViewer>
			);	
	}

	return (
		<React.Fragment>
	
			<DialogScenario setup={copyScenario} onClose={()=>{setCopyScenario({open:false})}} />
			<DialogSaveScenario setup={saveScenario} onClose={()=>{setSaveScenario({open:false});}} />
			<DialogDownloadScenario setup={downloadScenario} onClose={()=>{setDownloadScenario({open:false});}} />
			<DialogDeleteScenario setup={deleteScenario}  onClose={()=>{setDeleteScenario({open:false})}} />
			
			<DialogOwner setup={editOwner} onClose={(e)=>{setEditOwner({open:false, owner:false})}} />
			<DialogSetMain setup={setMain} onClose={()=>{setSetMain({open:false});}} />
			<DialogRequestOwners setup={requestLandOwners} projectid={params.id} scenario={scenario} workMode={workMode} onClose={()=>{setRequestLandOwners({open:false});}} />
			<DialogDisassociateProperty setup={disassocProp} onDelete={(property, owner)=>{handleDisassociateProperty(property, owner)}} onClose={()=>{setDisassocProp({open:false});}} />
			<DialogNotes setup={addNotes}	onAdd={handleAddNotes} projectid={params.id} user={user} onClose={()=>{setAddNotes({open:false});}} />
			<DialogTerminate setup={terminate} projectid={params.id} user={user} onClose={()=>{setTerminate({open:false});}} />
			<DialogChangeColor setup={changeColor} user={user} onClose={()=>{setChangeColor({open:false});}} />
			<DialogAssociateOwner setup={assocDialog} onClose={()=>{setAssocDialog({open:false});}} />
			<DialogProjectSettings user={user}  state={settingsDialog} onClose={(data)=>{handleSaveProject(data); setSettingsDialog({open:false})}} />
			<DialogVersions setup={versions} scenario={scenario} onClose={()=>{setVersions({open:false});}} />
			
			{dialogDrawing()}
			<div className="header">
			
				<div className="menu">
					<i className="ri-menu-2-fill"></i>
				</div>
				
				<div className="middle">
					
					<div className="title project-name">
						{!!project && project.name} 
						{versionid !== 0 && <sup className="project-version">V. {versionid}</sup>}
						{geoJson && scenario && 
							<div className="btn hoverDropdown p-0 ms-3">
								<Info weight="bold" size={16} />
								<div className="hoverContent-wrp">
									<div className="hoverContent">
										<div className="dropdown-menu-header">
											<h6 className="dropdown-menu-title">Project details</h6>
										</div>
										<div className="container">

											<Row>
												<Col>
													<Key weight="bold" size={13} /> ID: {params.id}
												</Col>
												<Col>
													<House weight="bold" size={13} /> {scenario.landowners.length} properties
												</Col>
											</Row>
											<Row>
												<Col>
													<Resize weight="bold" size={13} /> {formatAreaFromKm(scenario.stats.size ? scenario.stats.size : 0, user)}
												</Col>
												<Col>
													{project.energy_type.toLowerCase() == "wind" && 
														<><TurbineIcon weight="bold" size={13} /> {scenario.stats.numTurbines} turbines</>
													}
													{project.energy_type.toLowerCase() == "solar" && 
														<><SolarPanel weight="bold" size={13} /> {scenario.stats.numTurbines} panels</>
													}
												</Col>
											</Row>
											<Row>
												<Col>
													<UserSquare weight="bold" size={13} /> {scenario.landowners.filter((l)=>{return !!l.color}).length} landowners
												</Col>
												<Col>
													<Lightning weight="bold" size={13} /> {project.size.toFixed(1)} MW
												</Col>
											</Row>
		
										</div>
	
									</div>
								</div>
							</div>
						}
					</div>
					{!!project &&
					<div className="project-state">
						<Badge bg="" className="me-2 rounded" style={projectPhaseColors.colors(project.phase)}>{project.phase}</Badge>
						<Badge bg="" className="me-2 rounded" style={projectStatusColors.colors(project.state)}>{project.state}</Badge>
					</div>
					}
				</div>
				<div className="logo">
					<img className="img-fluid d-none d-md-block brand-logo" src="/images/vindr_logo_blue.svg" alt="Vindr"/>
				</div>
				<div className="options">
							<ProjectQuickSearch />
				
							{!!project && !!project.documentsURL &&
								<a className="btn btn-outline-primary" href={project.documentsURL} target="_blank"><Files weight="bold" size={16} /></a>
							}
							{!!project &&
							<div className="btn btn-outline-primary" onClick={()=>{handleEditProject(project)}}><PencilSimple weight="bold" size={16} /></div>
							}
							<div className="btn btn-outline-primary clickDropdown" onClick={
								(e)=>{
									e.stopPropagation();
									var elem = e.target.closest('.clickDropdown');
									elem.classList.toggle('active');
									document.body.addEventListener('click', () => {
										elem.classList.remove("active");
									}, { once: true });
							}}>
								{/*<small>{!!project.notes && project.notes.length}</small>*/}
								<Notepad weight="bold" size={16} />
								<div className="clickContent-wrp" onClick={(e)=>{}}>
									<div className="clickContent">
										<div className="dropdown-menu-header">
											<h6 className="dropdown-menu-title">Project notes</h6>
											<Button variant="primary" size="sm ms-auto" onClick={(e)=>{setAddNotes({open:true});e.stopPropagation();}}>Add Note</Button>
										</div>

										<ul className="list-group">
											{

												!!project && project.notes && project.notes.map((note, j)=>{
													var d = formatDate(note.date, 'natural');


													return (
														<li className="list-group-item" key={j}>
															<div className="msg-wrp">
																<div className="msg-body">
																	<small>{note.username}</small>
																	{note.note}
																	<small>{d}</small>
																</div>
															</div>
														</li>
													)
												})
											}
										</ul>


										<div className="dropdown-menu-footer">
											
										</div>
									</div>
								</div>
							</div>

						
						{saveButton()}
						<Link onClick={(e)=>{showHasChanges(e);}} to="/pages/projects" className="btn btn-outline-primary">Close</Link>
						{/*
						<Dropdown className="btn btn-outline-primary minimal ms-3">
							<Dropdown.Toggle variant="outline-primary"><DotsThreeVertical size={16} /></Dropdown.Toggle>
							<Dropdown.Menu>
								<Dropdown.Item href="#" onClick={(e)=>{}}><Notebook size={16} /> Notes</Dropdown.Item>
								<Dropdown.Item href="#" onClick={(e)=>{setVersions({open:true});}}><BookOpen size={16} /> Versions</Dropdown.Item>
								<Dropdown.Item href="#" onClick={(e)=>{}}><PencilSimple size={16} /> Rename</Dropdown.Item>
								<Dropdown.Item href="#" onClick={(e)=>{}}><DeviceRotate size={16} /> Edit state</Dropdown.Item>
							</Dropdown.Menu>
						</Dropdown> 
						*/}
				</div>
			</div>
			<div className="body project">
				<Sidebar hideMenu={true} hideLogo={true} prepend={scenarioSidebar()} add={ProjectSidebar()} />
				<div className={"main project " + (panoramicImage.url ? 'with-image' : '')}>
					<div className="map-wrapper">
						{showErrors()}
						<div ref={mapContainer}	className="project-map" />
						
						<LayerPanel ref={layerPanelRef} project={project} context={context} selected={selectedBaseLayer} map={map} options={mapStyles.map((v,k)=>{return {"label":v.label,"value":k}})} view3d={t3d} onChange={changeBaseLayer}	/>
						
						<PowerRoadsPanel setup={pwrRdsPanel} onClose={()=>{setPwrRdsPanel({open:false});}} />
					</div>
					{panoramicPanel()}
					{showStatuses()}
					{dialog3d()}
				</div>
				{!!project &&
				<ServiceBar ref={servBarPanel} map={map.current} content={[]}>
			
					{!owner && !land && !tc.handler &&
					<Tabs defaultActiveKey={workMode.value} onSelect={(v)=>{changeWorkMode(v, project)}} id="workmode-select" className="mb-3" >
					
						{wmConfig.workmodes.map((wm, idx)=>{
							var code = Country.getCode(project.country);
							if(wm.countries.includes(Country.getCode(project.country)) && wm.visible)
								return <Tab eventKey={wm.value} key={idx} title={wm.label}></Tab>
						})}
						
					</Tabs>
					}
					{landInfo()}
					{landOwner()}
					{landOwners()}
					{
					!owner && !land && lands()
					}
					{workMode.value != '' &&
						<Container>
							<Row className="status-switch">	
								<Col xs="12">
									<Form.Check id={"property_status"} value="1" onClick={(e)=>{changeProjectLayer(e)}} type="switch" defaultChecked={projectLayer.value == 'status'} /> Property Status
								</Col>
							</Row>
						</Container>
					}
				</ServiceBar>
				}
			</div>
	
			
			
			
			<Loader loaded={loaded} message="Loading project..." />
				
		</React.Fragment>
	);
}
